import { DISTANCE_TOLERANCE_PERCENT_RANGE } from '@chukua/common';
import { Form, InputNumber } from 'antd';

/** How far a closed-out trip's odometer distance and GPS distance may differ before the trip is flagged in Close-out (gitaumoses4/chukua#109). */
export function DistanceToleranceFields() {
  return (
    <div className="grid gap-x-4 sm:grid-cols-2">
      <Form.Item
        name="distanceTolerancePercent"
        label="Distance tolerance (%)"
        className="mb-0"
        rules={[{ required: true, message: 'Enter a percentage' }]}
        extra="A gap between the odometer and GPS distance above this share of the odometer distance is flagged. A change applies to trips compared afterwards, not to ones already answered."
      >
        <InputNumber className="w-full" min={DISTANCE_TOLERANCE_PERCENT_RANGE.min} max={DISTANCE_TOLERANCE_PERCENT_RANGE.max} precision={0} />
      </Form.Item>
    </div>
  );
}
